import { render } from "./AuthForm.vue?vue&type=template&id=a85a804e&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=a85a804e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85a804e"]])

export default __exports__